<template>
    <div class="container-fluid bg-orange-custom py-3">
        <div class="row">
            <div class="col-md-3 mb-3 mb-md-0">
                <div class="fw-bold fs-5 text-uppercase">{{ $t('issueLog.customer_name') }}</div>
                <div class="mt-2 fs-5 text-white">{{ customer.name }}</div>
            </div>
            <div class="col-md-3 mb-3 mb-md-0">
                <div class="fw-bold fs-5 text-uppercase">{{ $t('issueLog.customer_lastname') }}</div>
                <div class="mt-2 fs-5 text-white">{{ customer.lastname }}</div>
            </div>
            <div class="col-md-3 mb-3 mb-md-0">
                <div class="fw-bold fs-5 text-uppercase">{{ $t('issueLog.customer_document') }}</div>
                <div class="mt-2 fs-5 text-white">{{ customer.document }}</div>
            </div>
            <div class="col-md-3 mb-3 mb-md-0">
                <div class="fw-bold fs-5 text-uppercase">{{ $t('issueLog.permission_id') }}</div>
                <div class="mt-2 fs-5 text-white">{{ customer.permissionId }}</div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import type {CustomerInterface} from "@/components/helpers/Interfaces.ts";

const {customer} = defineProps<{
    customer: CustomerInterface
}>()
</script>

<style scoped>

</style>
